import {
	WeaLocaleProvider
} from 'ecCom';
import {addContentPath} from '../../util/index.js'
const getLabel = WeaLocaleProvider.getLabel;

export default () => {
	return (
		<div className='hrm-resource-id-verify-hint'>
			{`${getLabel(508043,'您还未设置二次验证密码')}, ${getLabel(508044,'点击')} `}
			<a href={addContentPath('/spa/hrm/index_mobx.html#/main/hrm/password?tabKey=2')} target='_blank'>{getLabel(30747,'设置')}</a>
		</div>
	)
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/financeExpand/Link.js